export const CREATE_NEW_ENTITY = 'Create a new Messenger ad';
export const HEADER_ICON_TOOLTIP_TEXT =
  'Create enticing opt-in pages for your Facebook "Send to Messenger" advertisements.';
export const ADD_ENTITY_TEXT = 'New Messenger Ad';
export const PANEL_NAME = 'Click-To-Messenger Ads';
export const JSON_ICON_TOOLTIP_TEXT =
  // tslint:disable-next-line:max-line-length
  'Copy the code below in full. Go to the "Ad Setup" in your Facebook Ad. Click "Messenger Setup". Click "JSON" tab. Click the first bracket and delete all of the default code. Paste the copied code from Customers.ai and click "Done"';
export const REF_TOOLTIP_TEXT =
  // tslint:disable-next-line:max-line-length
  'Copy the text below in full. Go to the "Ad Setup" in your Facebook Ad. Click "Show Advanced Options". Paste this into "URL Parameters"';
export const DEFAULT_ENTITY_NAME = 'Untitled Messenger Ad 1';
export const CONFIRM_DELETE_ENTITY_TEXT = 'Delete ad?';
